import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';

import { Http } from '../../support';
import { useStore } from '../../store';
import EmisoresList from './list/EmisoresList';
import LoadingButton from '../../facturotopia/LoadingButton';
import EmisoresSearch from './list/components/EmisoresSearch';
import EmisorListItemActions from './list/components/EmisorListItemActions';

class Emisores extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    this.props.csdActions.reset();
    this.props.infoActions.reset();
    this.props.upsertActions.reset();

    window.setAppTitle('Emisores');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = async (data) => {
    await this.props.infoActions.setPartialState({ data });
    await this.props.csdActions.setPartialState({ data });

    this.props.history.push({
      pathname: `/app/emisores/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true,
    });

    try {
      const { filters } = this.props.list;

      const params = {
        download: 1,
        ...filters,
      };

      const response = await Http.get(`${window.BONJOUR_URL}/api/emisores`, { params, responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar los emisores',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { selectedRowKeys, selectedRows, busy } = this.state;

    return (
      <div>
        <Row className="mb-3">
          <Col>
            {(Guardian.allows('multiemisor.access') || this.props.list.length === 0) &&
              Guardian.allows('emisor.crear') && (
                <Link
                  to="/app/emisores/registrar"
                  className="mr-3"
                >
                  <Button>Nuevo Emisor</Button>
                </Link>
              )}

            {Guardian.allows('emisor.descargar') && (
              <LoadingButton
                variant="secondary"
                onClick={this.handleOnDownloadActionClick}
              >
                {busy === true ? 'Descargando' : 'Descargar'}
              </LoadingButton>
            )}

            {selectedRowKeys.length > 0 && (
              <EmisorListItemActions
                selectedRowKeys={selectedRowKeys}
                selectedRows={selectedRows}
              />
            )}
          </Col>

          <Col
            xs={12}
            sm={6}
            md={6}
            lg={6}
            className="text-right"
          >
            <EmisoresSearch />
          </Col>
        </Row>

        {Guardian.allows('emisor.listar') && (
          <EmisoresList
            onRowClick={this.handleOnRowClick}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </div>
    );
  }
}

const mapState = (store) => {
  return {
    csd: store.app.emisores.csd,
    list: store.app.emisores.list,
    info: store.app.emisores.info,
    upsert: store.app.emisores.upsert,
  };
};

const mapActions = (actions) => {
  return {
    csdActions: actions.app.emisores.csd,
    listActions: actions.app.emisores.list,
    infoActions: actions.app.emisores.info,
    upsertActions: actions.app.emisores.upsert,
  };
};

export default connect(useStore, mapState, mapActions)(Emisores);
